import type { PrV2CommentTarget, PrV2Tab } from './tabs';

/** Window event name used to coordinate PR V2 tab switches across listeners. */
export const PR_V2_TAB_HANDOFF_EVENT = 'pr-v2:tab-handoff';

/** A tab to switch to, or a comment to open on its tab. */
export type PrV2TabHandoffPayload = PrV2Tab | PrV2CommentTarget;

/** Dispatches a browser event that asks PR V2 to switch to the provided tab. */
export function dispatchPrV2TabHandoff(payload: PrV2TabHandoffPayload): void {
  if (typeof window === 'undefined') {
    return;
  }

  const detail = typeof payload === 'string' ? { tab: payload } : payload;

  window.dispatchEvent(
    new CustomEvent<{ tab: PrV2Tab } | PrV2CommentTarget>(PR_V2_TAB_HANDOFF_EVENT, {
      detail,
    }),
  );
}
